<div>
    <div class="container red">
        <h1 class="center">404 Not found! ¯\_(ツ)_/¯</h1>
    </div>
</div>